import { useState } from "react";
import { styles } from "../styles";
import BackButton from "../components/BackButton";

export default function DeletedItemsPage({
  customers,
  actions,
  user,
  globalAuditLog,
  onBack,
}) {
  const [showGlobalAuditLog, setShowGlobalAuditLog] = useState(false);

  const deletedContacts = [
    ...customers.flatMap((c) =>
      (c.contacts || [])
        .filter((contact) => contact.deleted)
        .map((contact) => ({
          ...contact,
          customerName: c.name,
          locationName: null,
        }))
    ),
    ...customers.flatMap((c) =>
      (c.locations || []).flatMap((loc) =>
        (loc.contacts || [])
          .filter((contact) => contact.deleted)
          .map((contact) => ({
            ...contact,
            customerName: c.name,
            locationName: loc.name,
          }))
      )
    ),
  ];

  const deletedRecords = customers.flatMap((c) =>
    (c.locations || []).flatMap((loc) =>
      (loc.equipment || []).flatMap((eq) =>
        (eq.serviceRecords || [])
          .filter((record) => record.deleted)
          .map((record) => ({
            ...record,
            customerName: c.name,
            locationName: loc.name,
            equipmentName: eq.type,
          }))
      )
    )
  );

  const restoreContact = async (contactId) => {
    await actions.restoreContact(contactId, user?.email);
  };

  const permanentlyDeleteContact = async (contactId) => {
    const confirmed = window.confirm(
      "Permanently delete this contact?\n\nThis cannot be undone."
    );
    if (!confirmed) return;
    await actions.permanentlyDeleteContact(contactId, user?.email);
  };

  const restoreServiceRecord = async (recordId) => {
    await actions.restoreServiceRecord(recordId, user?.email);
  };

  const permanentlyDeleteServiceRecord = async (recordId) => {
    const confirmed = window.confirm(
      "Permanently delete this service record?\n\nThis cannot be undone."
    );
    if (!confirmed) return;
    await actions.permanentlyDeleteServiceRecord(recordId, user?.email);
  };

  return (
    <>
      <BackButton onClick={onBack} />

      <h2>Deleted Items</h2>

      <h3>Deleted Contacts</h3>
      {deletedContacts.length === 0 ? (
        <p>No deleted contacts.</p>
      ) : (
        deletedContacts.map((contact) => (
          <div key={contact.id} style={styles.card}>
            <strong>{contact.type}</strong>
            <br />
            <strong>Name:</strong> {contact.name}
            <br />
            <strong>Customer:</strong> {contact.customerName}
            <br />
            <strong>Location:</strong> {contact.locationName || "(customer-level)"}
            <br />
            <strong>Phone:</strong> {contact.phone || "-"}
            <br />
            <strong>Email:</strong> {contact.email || "-"}
            <br />
            <strong>Deleted By:</strong> {contact.deletedBy || "unknown"}
            <br />
            <strong>Deleted At:</strong> {contact.deletedAt || "-"}
            <br />
            <button
              style={styles.button}
              onClick={() => restoreContact(contact.id)}
            >
              Restore Contact
            </button>
            <button
              style={styles.button}
              onClick={() => permanentlyDeleteContact(contact.id)}
            >
              Permanently Delete
            </button>
          </div>
        ))
      )}

      <h3>Deleted Service Records</h3>
      {deletedRecords.length === 0 ? (
        <p>No deleted service records.</p>
      ) : (
        deletedRecords.map((record) => (
          <div key={record.id} style={styles.card}>
            <strong>{record.date}</strong>
            <br />
            <strong>Customer:</strong> {record.customerName}
            <br />
            <strong>Location:</strong> {record.locationName}
            <br />
            <strong>Equipment:</strong> {record.equipmentName}
            <br />
            <strong>Notes:</strong>
            <div style={{ whiteSpace: "pre-wrap", marginTop: "6px" }}>
              {record.notes || "-"}
            </div>
            <br />
            <strong>Deleted By:</strong> {record.deletedBy || "unknown"}
            <br />
            <strong>Deleted At:</strong> {record.deletedAt || "-"}
            <br />
            <button
              style={styles.button}
              onClick={() => restoreServiceRecord(record.id)}
            >
              Restore
            </button>
            <button
              style={styles.button}
              onClick={() => permanentlyDeleteServiceRecord(record.id)}
            >
              Permanently Delete
            </button>
          </div>
        ))
      )}

      <button
        style={styles.button}
        onClick={() => setShowGlobalAuditLog(!showGlobalAuditLog)}
      >
        {showGlobalAuditLog
          ? "Hide Global Audit Log"
          : "Show Global Audit Log"}
      </button>

      {showGlobalAuditLog && (
        <>
          <h3>Global Audit Log</h3>
          {(globalAuditLog || []).length === 0 ? (
            <p>No global audit history.</p>
          ) : (
            (globalAuditLog || []).map((entry) => (
              <div key={entry.id} style={styles.card}>
                <strong>{entry.action}</strong>
                <br />
                {entry.details}
                <br />
                <span style={{ fontSize: "12px", color: "#666" }}>
                  {entry.user} — {entry.timestamp}
                </span>
              </div>
            ))
          )}
        </>
      )}
    </>
  );
}
